jQuery(document).ready(function($){
    // Hide the dropdown on page load
    $('.drop-down-wrap').hide();

    // When the label is clicked
    $('.drop-down-wrap-list .label_drop_lab').click(function(){
        $('.drop-down-wrap').toggle(); // Toggle the visibility of the dropdown
    });

    // When any swatch-element1 is clicked
    $('.swatch-element1').click(function(){
        $('.drop-down-wrap').hide(); // Hide the dropdown
    });
});

